import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from "@angular/core";
import {GpsPermissionType} from "../../../../agents/types/gps-permission.type";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {LocationType} from "../../../../commons/types/location.type";
import * as moment from "moment";
import {RouterService} from "../../../../commons/angular/services/router.service";
import {TaskType} from "../../../../tasks/types/task.type";
import {AgentType} from "../../../../agents/types/agent.type";
import {AgentStatusType} from "../../../../agents/types/agentStatus.type";
import {TagType} from "../../../../tags/angular/types/tag.type";

require('./agent-progress-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-agent-progress-table-row',
  templateUrl: './agent-progress-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentProgressTableRowComponent implements OnChanges {

  @Input() agentProgress: any;
  @Input() enabledColumnsMap: any;

  @Output() askToEnableGpsEvent = new EventEmitter<{ agentPnType: string, agentId: string }>();
  @Output() askToEnableGpsPermissionsEvent = new EventEmitter<{ agentPnType: string, agentId: string }>();
  @Output() askToClockIn = new EventEmitter<{ agentPnType: string, agentId: string }>();
  @Output() swapServicesEvent = new EventEmitter<AgentModel>();
  @Output() viewTasksEvent = new EventEmitter<{ agent: any, tasks: TaskModel[] }>();
  @Output() viewAgentItineraryEvent = new EventEmitter<null>();


  public gpsPermissionType: typeof GpsPermissionType = GpsPermissionType;
  public currentTask: TaskModel;
  public currentTaskFromGeoEvents: TaskModel;
  public currentTaskFromGeoEventsServiceTime: number;
  public locationTypes: typeof LocationType = LocationType;
  public currentTaskPurposeColor: string;
  public currentTaskFromGeoEventPurposeColor: string;
  public taskType: typeof TaskType = TaskType;
  public agentType: typeof AgentType = AgentType;
  public agentStatusType: typeof AgentStatusType = AgentStatusType;
  public tagTypes: typeof TagType = TagType;

  constructor(@Inject(RouterService) private routerService: RouterService, @Inject('commonsDialogService') private commonsDialogService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.agentProgress) {
      this.initCurrentTaskData();
      this.initCurrentTaskFromGeoEventsData();
    }
  }

  private initCurrentTaskData() {
    this.currentTask = undefined;
    this.currentTaskPurposeColor = undefined;
    if (!!this.agentProgress.currentTaskId) {
      this.currentTask = this.agentProgress.tasks.find(t => t.id === this.agentProgress.currentTaskId);

      if (!!this.currentTask) {
        if (this.currentTask.taskSpec.purpose === 'Pickup') {
          this.currentTaskPurposeColor = '#FF9936';
        } else if (this.currentTask.taskSpec.purpose === 'Dropoff') {
          this.currentTaskPurposeColor = '#2196F3';
        } else if (this.currentTask.taskSpec.purpose === 'Operation') {
          this.currentTaskPurposeColor = '#2EBDA4'
        } else {
          this.currentTaskPurposeColor = '#616161';
        }
      }
    }
  }

  private initCurrentTaskFromGeoEventsData() {
    this.currentTaskFromGeoEvents = undefined;
    this.currentTaskFromGeoEventPurposeColor = undefined;
    if (!!this.agentProgress.currentTaskIdFromGeoEvents) {
      this.currentTaskFromGeoEvents = this.agentProgress.tasks.find(t => t.id === this.agentProgress.currentTaskIdFromGeoEvents);

      if (!!this.currentTaskFromGeoEvents) {
        if (this.currentTaskFromGeoEvents.taskSpec.purpose === 'Pickup') {
          this.currentTaskFromGeoEventPurposeColor = '#FF9936';
        } else if (this.currentTaskFromGeoEvents.taskSpec.purpose === 'Dropoff') {
          this.currentTaskFromGeoEventPurposeColor = '#2196F3';
        } else if (this.currentTaskFromGeoEvents.taskSpec.purpose === 'Operation') {
          this.currentTaskFromGeoEventPurposeColor = '#2EBDA4'
        } else {
          this.currentTaskFromGeoEventPurposeColor = '#616161';
        }

        if (!!this.currentTaskFromGeoEvents.taskEndTimeByGeoEvents) {
          this.currentTaskFromGeoEventsServiceTime = this.currentTaskFromGeoEvents.taskEndTimeByGeoEvents - this.currentTaskFromGeoEvents.taskStartTimeByGeoEvents
        } else {
          this.currentTaskFromGeoEventsServiceTime = moment().valueOf() - this.currentTaskFromGeoEvents.taskStartTimeByGeoEvents;
        }
      }
    }
  }

  onViewServiceDrillDown(task: TaskModel, event) {

    if (task.taskType === this.taskType.BundledStopover) {
      const serviceIds = task.bundledTaskList.map(task => {
        return {
          id: task.serviceId
        }
      })
      this.commonsDialogService.displayEntityLinksList('service.delivery.info', serviceIds, undefined, event);
    } else {
      this.routerService.routeToNewTab('service.delivery.info', {id: task.serviceId});
    }
  }

}
